import { __exports as e } from "../../../_virtual/isAlphanumeric.js";
import { a as r } from "./util/assertString.js";
import "./alpha.js";
import { __exports as a } from "../../../_virtual/alpha.js";
Object.defineProperty(e, "__esModule", {
  value: !0
}), e.default = function (e) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "en-US",
    t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  (0, o.default)(e);
  var i = e,
    l = t.ignore;
  if (l) {
    if (l instanceof RegExp) i = i.replace(l, "");else if ("string" == typeof l) i = i.replace(RegExp("[".concat(l.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");else throw Error("ignore should be instance of a String or RegExp");
  }
  if (r in a.alphanumeric) return a.alphanumeric[r].test(i);
  throw Error("Invalid locale '".concat(r, "'"));
}, e.locales = void 0;
var o = r && r.__esModule ? r : {
    default: r
  },
  t = Object.keys(a.alphanumeric);
e.locales = t;